import React, { Component } from "react";
import { Image } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Link, withRouter } from "react-router-dom";
import { get } from "lodash";
import { toast } from "react-toastify";
import { dateFormatWithTime, isValidArray } from "../../helper";
import { PATHS, STATUS } from "../../constant";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getNotificationsStatus,
  getDashboardNotifications,
  getDashboardNotificationsViewed
} from "../../actions/dashboard.action";
import LoaderTemplate from "../../component/LoaderTemplate";
import { NotificationTemplate } from "../../component/LoadersTemplate";
import NoDataFound from "../../component/NoDataFound";
import LoadListOnScroll from "../../component/loadListOnScroll";
import MigrationSucces from "../../assets/migration-success-icon.svg";
import MigrationLoader from "../../assets/Migration_Loader.gif";
import { getMigrationLists } from "../../services/apiServices";
import request from "../../services/requestService";
import { successToastStyle, errorToastStyle } from "../../customToast";
class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      issueList: [],
      notifyStatus: false,
      closeNotification: false,
      offset: 0,
      _myNotificationData: [],
      projectmigrationmsg: null,
      notificationFlag: false,
      createdDate: "",
      notificationCalled: false
    };
  }

  componentDidMount = async () => {
    let { getDashboardNotifications } = this.props;
    let resp = await getDashboardNotifications(undefined, {
      offset: 0,
      limit: 20
    });
    if (resp) {
      this.setState({
        _myNotificationData: [...this.state._myNotificationData, ...resp]
      });
    }
  };

  componentWillReceiveProps(nextProps, nextContext) {
    let { _myNotificationData } = this.state;
    let { notifyData } = nextProps;
    if (notifyData && notifyData.length) {
      this.setState({
        _myNotificationData: notifyData
      });
    }
    this.setState({
      isAllDataLoaded: !isValidArray(_myNotificationData)
    });
  }
  componentDidUpdate(prevProps) {
    const { taskID, notificationFlag } = this.props;
    const data = this.state._myNotificationData[0];
    if (taskID && taskID !== prevProps.taskID) {
      this.getMigrationAPI(taskID);
    }
    if (notificationFlag && notificationFlag !== prevProps.notificationFlag) {
      this.setState({ notificationFlag: notificationFlag });
    }
    if (
      data &&
      data.message.includes("is in progress.") &&
      !this.state.notificationCalled // <-- ensure run only once
    ) {
      this.getMigrationAPI(data.displayId);
      this.setState({ notificationCalled: true });
    }
  }
  getMigrationAPI = async taskId => {
    let downloadStatus = false;
    let retryCount = 0;
    const maxRetries = 10000;
    const retryDelay = 2000;
    //const { getUsersListDispatch } = this.props;
    while (!downloadStatus && retryCount < maxRetries) {
      try {
        const downloadResponse = await request(getMigrationLists(taskId));
        if (downloadResponse.data.data.status === "IN PROGRESS") {
          this.setState({
            createdDate: downloadResponse.data.data.createdDate
          });
        } else if (downloadResponse.data.data.status === "COMPLETED") {
          downloadStatus = true;
          const message = downloadResponse.data.data.message;
          this.setState({
            projectmigrationmsg: "COMPLETED",
            notificationFlag: false,
            createdDate: downloadResponse.data.data.updatedDate
          });
          let { getDashboardNotifications } = this.props;
          let resp = await getDashboardNotifications(undefined, {
            offset: 0,
            limit: 20
          });
          if (resp) {
            this.setState({
              _myNotificationData: [...this.state._myNotificationData, ...resp]
            });
          }
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          this.props.migrationAPICall(Date.now());
          break;
        } else if (downloadResponse.data.data.status === "PARTIAL COMPLETED") {
          downloadStatus = true;
          const message = downloadResponse.data.data.message;
          this.setState({
            projectmigrationmsg: "PARTIAL COMPLETED",
            notificationFlag: false,
            createdDate: downloadResponse.data.data.updatedDate
          });
          let { getDashboardNotifications } = this.props;
          let resp = await getDashboardNotifications(undefined, {
            offset: 0,
            limit: 20
          });
          if (resp) {
            this.setState({
              _myNotificationData: [...this.state._myNotificationData, ...resp]
            });
          }
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          this.props.migrationAPICall(Date.now());
          break;
        } else if (downloadResponse.data.data.status === "FAILED") {
          downloadStatus = true;
          const message = downloadResponse.data.data.message;
          this.setState({
            projectmigrationmsg: "FAILED",
            notificationFlag: false,
            createdDate: downloadResponse.data.data.updatedDate
          });
          let { getDashboardNotifications } = this.props;
          let resp = await getDashboardNotifications(undefined, {
            offset: 0,
            limit: 20
          });
          if (resp) {
            this.setState({
              _myNotificationData: [...this.state._myNotificationData, ...resp]
            });
          }
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
          this.props.migrationAPICall(Date.now());
          break;
        } else {
          retryCount++;
          await new Promise(resolve => setTimeout(resolve, retryDelay));
        }
      } catch (error) {
        retryCount++;
        if (retryCount < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, retryDelay));
        } else {
          console.error("Maximum download retries reached. Download failed.");
          break; // Exit the loop after maximum retries
        }
      }
    }
  };
  notifyStatus = notification => {
    const {
      assetId,
      subAssetId,
      notificationAsset,
      redirectMeeting
    } = notification;
    if (notificationAsset === "PROJECT") {
      return {
        pathname: PATHS.PROJECT_DETAILS,
        search: `projectId=${assetId}`,
        state: {
          projectId: assetId
        }
      };
    } else if (notificationAsset === "ISSUE") {
      return {
        pathname: PATHS.ISSUE_DETAIL,
        search: `?issueId=${assetId}&&projectId=${subAssetId}&&momId=${assetId}`
      };
    } else if (notificationAsset === "MEETING" && redirectMeeting) {
      return {
        pathname: PATHS.AGENDA_DETAILS,
        search: `?agendaId=${assetId}`,
        state: {
          agendaId: assetId
        }
      };
    }
    return {
      pathname: null
    };
    // switch (notification) {
    //   case "PROJECT":
    //     return PATHS.PROJECT_DETAILS;
    //   case "ISSUE":
    //     return PATHS.ISSUE_DETAIL;
    //   case "MEETING":
    //     return PATHS.AGENDA_DETAILS;
    //   default:
    //     return PATHS.PROJECT_DETAILS;
    // }
  };

  onNotifyClick = id => {
    const {
      notificationClick,
      getDashboardNotifications,
      history,
      location: { pathname, search }
    } = this.props;
    let { offset } = this.state;
    // getNotificationsStatus(undefined, id);
    getDashboardNotificationsViewed(undefined, id);
    getDashboardNotifications(undefined, { offset: offset, limit: 20 });
    notificationClick && notificationClick();
    if (pathname && search) {
      history.push(`${pathname}${search}`);
    }
  };

  loadPageOnScroll = async () => {
    const { isAllDataLoaded } = this.state;
    const { getDashboardNotifications, notificationStatus } = this.props;
    if (isAllDataLoaded) {
      return;
    }
    this.setState(
      {
        isAllDataLoaded: true,
        offset:
          notificationStatus !== STATUS.LOADING
            ? this.state.offset + 1
            : this.state.offset
      },
      async () => {
        const { offset } = this.state;
        if (notificationStatus !== STATUS.LOADING) {
          let resp = await getDashboardNotifications(undefined, {
            offset: offset,
            limit: 20
          });
          if (resp) {
            this.setState({
              _myNotificationData: [...this.state._myNotificationData, ...resp]
            });
          }
        }
      }
    );
  };

  closeNotification = () => {
    const { notificationClick } = this.props;
    notificationClick();
  };

  render() {
    const {
      placement,
      notificationOpen,
      notificationData,
      isLoading,
      setStatus,
      taskStatus,
      formName,
      toName
    } = this.props;
    const {
      offset,
      _myNotificationData,
      projectmigrationmsg,
      notificationFlag,
      createdDate
    } = this.state;
    const fromHeader = placement === "header" ? "from-header" : "";

    return (
      <React.Fragment>
        <div
          className={`notifications odd ${
            placement ? "header-notification" : ""
          } ${notificationOpen ? "active" : "inactive"}`}
        >
          {placement !== "header" ? (
            <div className="mobile-heading" onClick={setStatus}>
              <h3>Notifications</h3>
            </div>
          ) : (
            ""
          )}
          <div
            className={`notifications-inner popover-wrapper ${
              taskStatus === 3 ? "link-display" : ""
            }`}
          >
            {" "}
            {/* popover-visible */}
            <div
              className={`dashboard-heading-wrapper popover-title ${fromHeader}`}
              // onClick={this.closeNotification}
            >
              {setStatus && <div className="back-btn" onClick={setStatus} />}
              <h3>Notifications</h3>
              {placement === "header" ? (
                <div className="close-icon" onClick={this.closeNotification} />
              ) : (
                ""
              )}
            </div>
            <LoadListOnScroll
              callApiOnScroll={this.loadPageOnScroll}
              offset={offset}
            >
              {/* <PerfectScrollbar className="dashboard-cards">*/}
              <div className="scrollbar-wrapper">
                <ul className="scroll infinite-scroll-wrapper">
                  {notificationFlag ? (
                    <li class="migration-notification">
                      <Image
                        src={MigrationLoader}
                        className="mr-1 migration-loading-img"
                      />
                      <span className="migration-notification-text">
                        Project(s) Migration
                      </span>
                      &nbsp;&nbsp;
                      <span
                        className="activity-date"
                        style={{ verticalAlign: "bottom" }}
                      >
                        {dateFormatWithTime(createdDate)}
                      </span>
                      <span className="mt-2">
                        Migration of project(s) from{" "}
                        <strong className="activity-by">'{toName}'</strong> to{" "}
                        <strong className="activity-by">'{formName}'</strong> is
                        in progress. During this period, please avoid updating
                        the projects/issues or downloading flat-files.
                      </span>
                    </li>
                  ) : null}
                  {/* {projectmigrationmsg == "COMPLETED" ? (
                    <li class="migration-notification">
                      <Image
                        src={MigrationSucces}
                        className="mr-1 migration-success-img"
                      />
                      <span className="migration-notification-text">
                        Project(s) Migration
                      </span>
                      &nbsp;&nbsp;
                      <span
                        className="activity-date"
                        style={{ verticalAlign: "bottom" }}
                      >
                        {dateFormatWithTime(createdDate)}
                      </span>
                      <span className="mt-2">
                        Migration of Project(s) from{" "}
                        <strong className="activity-by">'{toName}'</strong> to{" "}
                        <strong className="activity-by">'{formName}'</strong>{" "}
                        <div style={{ display: "inline-block" }}>
                          completed succesfully
                        </div>
                      </span>
                    </li>
                  ) : null}
                  {projectmigrationmsg == "FAILED" ? (
                    <li class="migration-notification">
                      <Image
                        src={MigrationSucces}
                        className="mr-1 migration-success-img"
                      />
                      <span className="migration-notification-text">
                        Project(s) Migration
                      </span>
                      &nbsp;&nbsp;
                      <span
                        className="activity-date"
                        style={{ verticalAlign: "bottom" }}
                      >
                        {dateFormatWithTime(createdDate)}
                      </span>
                      <span className="mt-2">
                        Migration of Project(s) from{" "}
                        <strong className="activity-by">'{toName}'</strong> to{" "}
                        <strong className="activity-by">'{formName}'</strong> is{" "}
                        <div style={{ display: "inline-block" }}>failed</div>
                      </span>
                    </li>
                  ) : null}
                  {projectmigrationmsg == "PARTIAL COMPLETED" ? (
                    <li class="migration-notification">
                      <span>
                        <Image src={MigrationSucces} className="mr-1" />
                        Project(s) Migration
                      </span>
                      &nbsp;&nbsp;
                      <span
                        className="activity-date"
                        style={{ verticalAlign: "bottom" }}
                      >
                        {dateFormatWithTime(createdDate)}
                      </span>
                      <span className="mt-2">
                        Migration of Project(s) from{" "}
                        <strong className="activity-by">'{toName}'</strong> to{" "}
                        <strong className="activity-by">'{formName}'</strong> is{" "}
                        <div style={{ display: "inline-block" }}>
                          partially completed
                        </div>
                      </span>
                    </li>
                  ) : null} */}

                  {isLoading ? (
                    <LoaderTemplate
                      height={55}
                      speed={1}
                      times={9}
                      children={<NotificationTemplate />}
                    />
                  ) : isValidArray(_myNotificationData) ? (
                    _myNotificationData.map((notifyData, index) => {
                      const isMigration = notifyData.migrationLogo;
                      const url = !isMigration
                        ? this.notifyStatus(notifyData)
                        : null;

                      return isMigration ? (
                        /* ================= MIGRATION NOTIFICATION ================= */
                        <li
                          key={`migration-${notifyData.id}`}
                          className="migration-notification"
                        >
                          <Image
                            src={
                              notifyData.message.includes("is in progress.")
                                ? MigrationLoader
                                : MigrationSucces
                            }
                            className={
                              notifyData.message.includes("is in progress.")
                                ? "mr-1 migration-loading-img"
                                : "mr-1 migration-success-img"
                            }
                          />
                          <span className="migration-notification-text">
                            Project(s) Migration
                          </span>
                          &nbsp;&nbsp;
                          <span className="activity-date">
                            {dateFormatWithTime(notifyData.createdDate)}
                          </span>
                          <span className="mt-2">
                            Migration of Project(s) from{" "}
                            <strong className="activity-by">
                              '{notifyData.fromUser}'
                            </strong>{" "}
                            to{" "}
                            <strong className="activity-by">
                              '{notifyData.toUser}'
                            </strong>{" "}
                            <div
                              style={{
                                display: notifyData.message.includes(
                                  "is in progress."
                                )
                                  ? "contents"
                                  : "inline-block"
                              }}
                            >
                              {notifyData.message === "failed"
                                ? `has ${notifyData.message}`
                                : notifyData.message}
                            </div>
                          </span>
                        </li>
                      ) : (
                        /* ================= NORMAL NOTIFICATION ================= */
                        <li
                          key={`notification-${notifyData.id}`}
                          className="activity-history new-history"
                        >
                          <Link
                            to={url}
                            onClick={e => {
                              e.stopPropagation();
                              this.onNotifyClick(notifyData.id);
                            }}
                          >
                            <span className="issue-id">
                              {notifyData.displayId}
                            </span>
                            &nbsp;
                            <span className="activity-date">
                              {dateFormatWithTime(notifyData.createdDate)}
                            </span>
                            <span
                              className={`activity-by ${
                                notifyData.message.match(/[\u0900-\u097F]/)
                                  ? "hindi-text-wrap"
                                  : ""
                              }`}
                              style={{
                                lineHeight: notifyData.message.match(
                                  /[\u0900-\u097F]/
                                )
                                  ? 1.3
                                  : ""
                              }}
                            >
                              {notifyData.message}
                            </span>
                          </Link>
                        </li>
                      );
                    })
                  ) : (
                    <NoDataFound />
                  )}

                  {/* {isLoading ? (
                    <LoaderTemplate
                      height={55}
                      speed={1}
                      times={9}
                      children={<NotificationTemplate />}
                    />
                  ) : isValidArray(_myNotificationData) ? (
                    _myNotificationData.map((notifyData, index) => {
                      console.log(_myNotificationData);
                      return (
                        <li
                          class="migration-notification"
                          style={{
                            display: notifyData.migrationLogo ? null : "none"
                          }}
                        >
                          <Image
                            src={
                              notifyData.message.includes("is in progress.")
                                ? MigrationLoader
                                : MigrationSucces
                            }
                            className={
                              notifyData.message.includes("is in progress.")
                                ? "mr-1 migration-loading-img"
                                : "mr-1 migration-success-img"
                            }
                          />
                          <span className="migration-notification-text">
                            Project(s) Migration
                          </span>
                          &nbsp;&nbsp;
                          <span
                            className="activity-date"
                            style={{ verticalAlign: "bottom" }}
                          >
                            {dateFormatWithTime(notifyData.createdDate)}
                          </span>
                          <span className="mt-2">
                            Migration of Project(s) from{" "}
                            <strong className="activity-by">
                              '{notifyData.fromUser}'
                            </strong>{" "}
                            to{" "}
                            <strong className="activity-by">
                              '{notifyData.toUser}'
                            </strong>{" "}
                            <div
                              style={{
                                display: notifyData.message.includes(
                                  "is in progress."
                                )
                                  ? "contents"
                                  : "inline-block"
                              }}
                            >
                              {notifyData.message == "failed" ? (
                                <>has {notifyData.message}</>
                              ) : (
                                <>{notifyData.message}</>
                              )}
                            </div>
                          </span>
                        </li>
                      );
                    })
                  ) : null}
                  {isLoading ? (
                    <LoaderTemplate
                      height={55}
                      speed={1}
                      times={9}
                      children={<NotificationTemplate />}
                    />
                  ) : isValidArray(_myNotificationData) ? (
                    _myNotificationData.map((notifyData, index) => {
                      const url = this.notifyStatus(notifyData);
                      return (
                        <li
                          className={`activity-history new-history`}
                          key={`notification-${index}`}
                          style={{
                            display: notifyData.migrationLogo ? "none" : null
                          }}
                        >
                          <Link
                            to={url}
                            onClick={e => {
                              e.stopPropagation();
                              this.onNotifyClick(notifyData.id);
                            }}
                          >
                            <span className="issue-id">
                              {notifyData.displayId}
                            </span>{" "}
                            &nbsp;
                            <span className="activity-date">
                              {dateFormatWithTime(
                                get(notifyData, "createdDate", null)
                              )}
                            </span>
                            <span
                              className={`activity-by ${
                                notifyData.message.match(/[\u0900-\u097F]/)
                                  ? "hindi-text-wrap"
                                  : ""
                              }`}
                              style={{
                                lineHeight: notifyData.message.match(
                                  /[\u0900-\u097F]/
                                )
                                  ? 1.3
                                  : ""
                              }}
                            >
                              {notifyData.message}
                            </span>
                          </Link>
                        </li>
                      );
                    })
                  ) : (
                    <NoDataFound />
                  )} */}
                </ul>
              </div>
              {/* </PerfectScrollbar>*/}
            </LoadListOnScroll>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getNotificationsStatus: getNotificationsStatus,
      getDashboardNotifications
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    notifyStatusData: state.dashboardReducer.notifyStatusData,
    notificationStatus: state.dashboardReducer.notificationStatus
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Notification)
);
